import reportsHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/reports-header.png';
import reportsSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/reports-section1.png';
import reportsSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/reports-section2.png';
import reportsSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/reports-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_REPORTS: PageblockData = {
  headerData: {
    headerText: 'Access real-time insights with Salesforce reporting',
    subHeaderText:
      'Make data-driven decisions with advanced reporting and real-time dashboards that streamline your workflows and boost sales performance.',
    imgSrc: reportsHeader,
    imgAlt: 'Reports header',
    name: 'Reports',
  },
  pageTitle: 'Track key sales metrics & boost pipeline performance',
  section1: {
    imgSrc: reportsSection1,
    imgAlt: 'Reports section img',
    title: 'Improve funnel conversion',
    content:
      'Gain a clear understanding of your conversion rates across your sales funnels. Identify areas for improvement so you can optimize your process and boost your pipeline predictability.',
  },
  section2: {
    imgSrc: reportsSection2,
    imgAlt: 'Reports section 2 img',
    title: 'Track velocity across all funnels',
    content:
      'Track the velocity of records through the different steps of a deal to identify bottlenecks and opportunities for optimization',
  },
  section3: {
    imgSrc: reportsSection3,
    imgAlt: 'Reports section 3 img',
    title: 'Automatically update reports with funnel changes',
    content:
      'Experience dynamic reporting that adjusts in real-time with changes to your sales funnels, eliminating the need to manually rebuild reports.',
  },
};
